<tran-application-detail-dashboard-box
    heading="components.application-detail-dashboard.application-detail-approved-budget.heading"
>
    @if (isLoading()) {
        <div class="flex flex-col gap-3" aria-hidden="true">
            <span class="si-skeleton placeholder-lg w-[40%]"></span>
            <span class="si-skeleton placeholder-lg w-[35%]"></span>
        </div>
    } @else if (this.readonly()) {
        <tran-pill-row rowClasses="min-h-[44px] pt-2 font-bold">
            <tran-pill-cell bgColor="bg-deep-blue-800">
                <span class="p-1">
                    {{ 'components.application-detail-dashboard.application-detail-budget.sum' | translate }}</span
                >
            </tran-pill-cell>
            <tran-pill-cell bgColor="bg-deep-blue-750">
                <span class="p-1">{{ value() || 0 | currency: 'EUR' : 'symbol' : '1.0-0' }}</span>
            </tran-pill-cell>
        </tran-pill-row>
    } @else {
        <ng-container
            [ngTemplateOutlet]="numberInputField"
            [ngTemplateOutletContext]="{
                control: effectiveControl(),
                inputId: 'approved-budget',
                label: 'components.yearly-amounts.total',
                min: 0,
                max: 9_999_999_999_999.99,
                step: 1000,
                unit: '€',
                placeholder: 'components.yearly-amounts.example' | translate,
                errorTemplate: approvedBudgetErrors
            }"
        />
        @if (showFundingRatio()) {
            <ng-container
                [ngTemplateOutlet]="numberInputField"
                [ngTemplateOutletContext]="{
                    control: fundingRatioEffectiveControl(),
                    inputId: 'funding-ratio',
                    label: 'components.application-detail-dashboard.application-detail-approved-budget.funding-ratio',
                    min: 0,
                    max: 100,
                    step: 1,
                    unit: '%',
                    rowClasses: 'mt-4 flex items-start gap-4'
                }"
            />
        }
    }
    <ng-template
        #numberInputField
        let-control="control"
        let-inputId="inputId"
        let-label="label"
        let-min="min"
        let-max="max"
        let-step="step"
        let-unit="unit"
        let-placeholder="placeholder"
        let-rowClasses="rowClasses"
        let-errorTemplate="errorTemplate"
    >
        <div [class]="rowClasses || 'flex items-start gap-4'">
            <label class="w-60 pt-2 text-white" [for]="inputId">{{ label | translate }}</label>
            <div class="flex-1">
                <tran-number-input
                    [formControl]="control"
                    [disabled]="readonly() || control.disabled"
                    class="form-control text-start"
                    [inputId]="inputId"
                    [min]="min"
                    [max]="max"
                    [step]="step"
                    [unit]="unit"
                    [placeholder]="placeholder"
                />
                <ng-container [ngTemplateOutlet]="errorTemplate" [ngTemplateOutletContext]="{ control: control }" />
            </div>
        </div>
    </ng-template>
    <ng-template #approvedBudgetErrors let-control="control">
        @if (control.invalid && control.touched) {
            @if (control.errors?.['required']) {
                <div class="mt-2 text-sm text-danger">
                    {{ 'application-form.required' | translate }}
                </div>
            }
            @if (control.errors?.['min']) {
                <div class="mt-2 text-sm text-danger">
                    {{ 'components.yearly-amounts.min0' | translate }}
                </div>
            }
            @if (control.errors?.['max']) {
                <div class="mt-2 text-sm text-danger">
                    {{ 'components.yearly-amounts.max' | translate: { max: control.errors?.['max']?.max } }}
                </div>
            }
        }
    </ng-template>
</tran-application-detail-dashboard-box>
